export default __webpack_public_path__ + "static/Surt-SemiBold-60d3e3d446407d9f8b1bb908987b97c9.woff";